import React, { useMemo } from 'react';

import Accordion from 'components/Accordion';
import useModel from 'hooks/Meteorology/Weather/Comparator/useModel';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import RadioButton from 'components/DesignSystem/RadioButton';

export default function ModelAccordion({ modelIndex }: {
  modelIndex: number,
}) {
  const { models, getModels, setModels } = useModel();
  const closeAccordion = useMemo(() => buildAccordionClickFunction(`model-${modelIndex}-list`), [modelIndex]);

  return (
    <Accordion.Item eventKey="model" id={`model-${modelIndex}-list`}>
      <Accordion.Header>
        <TitleSemiBold>Modelo</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body className="d-grid control-panel-columns column-gap-3">
        {models.map((m) => (
          <RadioButton
            key={m.id}
            id={`model-${modelIndex}-radio-${m.id}`}
            className="text-uppercase"
            label={m.label}
            onChange={() => {
              setModels(m.id, modelIndex);
              closeAccordion();
            }}
            checked={m.id === getModels(modelIndex)}
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
